import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomGoBack from "../customGoBack/CustomGoBack";
import CustomTextBox from "../customTextBox/CustomTextBox";
import CustomButton from "../customButton/CustomButton";
import { resetPwd } from "../../api/forgotPwdApi";
import { LoadPanel } from "devextreme-react";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";

export default function ChangePasswordForm({ emailOtp, onChangePwdGoBack }) {
  const [newPassword, setNewPassword] = useState();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleChangePwdContinue = async () => {
    try {
      setLoading(true);
      const result = await resetPwd(emailOtp,newPassword);
      if (result?.status === 200 && result?.data) {
        ToastDisplayer("success", result.data.message);
        navigate("/feedbackPasswordPage"); 
      }
    } catch (error) {
      ToastDisplayer("error",error.response?.data?.error || "An unexpected error occurred.")
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <CustomGoBack onGoBack={onChangePwdGoBack} />

      <div className="resetHeader">New Password</div>
      <div className="resetText">
        Type new password to get the account setup
      </div>

      <CustomTextBox
        label="New Password"
        placeholder="Set your new password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.value)}
        type="password"
      />

      <div className="mySpace">
        <CustomButton text="Continue" onClick={handleChangePwdContinue} />
      </div>
    </>
  );
}
